import { Alert, Button, Intent, Tag } from "@blueprintjs/core";
import { IconNames } from "@blueprintjs/icons";
import { useState } from "react";
import css from "./PortfolioEditAlert.module.scss";

const IDS_SHOWN = 5;

export const PortfolioEditAlert: React.FC<{
    readonly projectIds: ReadonlyArray<string>;
    readonly onCancel: () => void;
    readonly onConfirm: () => void;
}> = ({ projectIds, onCancel, onConfirm }) => {
    const [showAll, setShowAll] = useState(false);
    const count = projectIds.length;
    return (
        <Alert
            isOpen
            intent={Intent.WARNING}
            icon={IconNames.WARNING_SIGN}
            cancelButtonText="Cancel"
            confirmButtonText="Continue"
            onCancel={onCancel}
            onConfirm={onConfirm}
        >
            <p>
                This scenario changes the size of{" "}
                {count === 1 ? "1 project" : `${count} projects`} in your
                portfolio.
            </p>
            <p>
                To leave your projects out of bulk edits, set the Projects
                filter to "Not in portfolio" first.
            </p>
            <div className={css["PortfolioEditAlert-ids"]}>
                {(showAll ? projectIds : projectIds.slice(0, IDS_SHOWN)).map(
                    (id) => (
                        <Tag key={id} minimal>
                            {id}
                        </Tag>
                    )
                )}
            </div>
            {count > IDS_SHOWN && (
                <Button
                    variant="minimal"
                    size="small"
                    intent={Intent.PRIMARY}
                    onClick={() => setShowAll((previous) => !previous)}
                >
                    {showAll ? "Show fewer" : `Show all ${count}`}
                </Button>
            )}
        </Alert>
    );
};
